import { makeAutoObservable } from 'mobx';
import { Message } from '@arco-design/web-react';
import { setTokenToLocalStorage } from '@/utils/token';
import { makePersistable } from 'mobx-persist-store';
import User from './user';
import { userLogin } from '@/api/modules/user';
interface IUserInfo {
  avatar_color: string;
  created_at: number;
  last_login: number;
  last_login_ip: string;
  nickname: string;
  phone_number: string;
  updated_at: number;
  uuid: string;
  password_strength: number;
}
class Login_to {
  token = null;
  user_info: IUserInfo;

  request_id = {};
  uuid = {};
  isSuccess = false;
  isLoading = false;
  team_id = null;

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'LoginStore',
      properties: ['uuid', 'user_info'],
      storage: window.localStorage,
    });
  }
  /***
   * 修改状态
   */
  someMethod(data) {
    const { token, user_info, request_id } = data;
    this.token = token;
    this.user_info = user_info;
    this.request_id = request_id;
    this.uuid = user_info.uuid;
    // your code here
  }
  /***
   *  当temid 为0的 时候 调用此接口
   */
  //   team_myteams_gettemid_to(data) {
  //     try {
  //       return team_addop(data).then((res) => {
  //         console.log(res);
  //         if (res?.code == 0 && res?.message == 'OK') {
  //           setTokenToLocalStorage(res.data.token);
  //           Message.success('创建团队成功');
  //           return true;
  //         } else {
  //           Message.info(res);
  //           return false;
  //         }
  //       });
  //     } catch (error) {
  //       console.error('Login failed:', error);
  //     } finally {
  //     }
  //     return false;
  //   }

  /***
   * 登陆
   */
  async Accc_use_login(datalist) {
    return new Promise((resolve, reject) => {
      userLogin(datalist)
        .then((res) => {
          console.log(33333333333, res);

          if (res?.code == 0) {
            this.someMethod(res.data);
            setTokenToLocalStorage(res.data.token);
            // this.isSuccess = true;
            //   this.team_id = res.data.team_id;
            //   User.getTeamInfo();
          } else {
            Message.info(res);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

const Login = new Login_to();
export default Login;
